import { api } from './apiClient';

export interface Uom {
  id: number;
  uom_code: string;
  uom_name: string;
  uom_category: string;
  is_active?: number | boolean;
}

export interface UomConversion {
  id: number;
  from_uom_id: number;
  to_uom_id: number;
  factor: number;
  from_code?: string;
  to_code?: string;
}

export const uomService = {
  getUoms: async (params?: { activeOnly?: boolean; category?: string }): Promise<{ uoms: Uom[]; count: number }> =>
    api.get('/uoms', { params }),

  getUom: async (id: number): Promise<{ uom: Uom }> => api.get(`/uoms/${id}`),

  createUom: async (data: { uomCode: string; uomName: string; uomCategory?: string; isActive?: boolean }): Promise<{ uom: Uom }> =>
    api.post('/uoms', data),

  updateUom: async (id: number, data: Partial<{ uomCode: string; uomName: string; uomCategory: string; isActive: boolean }>): Promise<{ uom: Uom }> =>
    api.put(`/uoms/${id}`, data),

  deleteUom: async (id: number): Promise<any> => api.delete(`/uoms/${id}`),

  getConversions: async (): Promise<{ conversions: UomConversion[]; count: number }> =>
    api.get('/uoms/conversions'),

  addConversion: async (data: { fromUomId: number; toUomId: number; factor: number }): Promise<{ conversion: UomConversion }> =>
    api.post('/uoms/conversions', data),

  removeConversion: async (id: number): Promise<any> => api.delete(`/uoms/conversions/${id}`),
};
